import isPreRendering from 'utils/isPreRendering'
import { hasLocationFilter } from '../../pages/Search/utils'
import clearPropertyReferenceStorage from '../../utils/clearPropertyReferenceStorage'

export const isQueryLocationSynced = (query, selectedLocalities) => {
  if (!hasLocationFilter(selectedLocalities)) return true

  return query.includes('search')
}
export const scrollToItem = () => {
  const reference = window.localStorage.getItem('propertyReference')

  if (!isPreRendering() && reference) {
    const referencedProperty = document.getElementById(reference)

    if (referencedProperty) {
      referencedProperty.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }
    clearPropertyReferenceStorage()
  }
}
